import $ from 'jquery';
import batws from 'lib/services/batws';
import xformDealersCommon from 'lib/transforms/dealer.tmpl.common';
  // Does this zip contain ANY dealers that participate in RTI (Real Time Inventory, aka GXP)?
  // If so, get dealers for this zip & return PMA dealers, for checking elsewhere
  // BATWS does not contain this equivelant (&attributeKey=rti) so can't use rest API
  // it looks like Seeger is in ALL of these responses... does that mean there's always an RTI participant
  // in any search on KAC? if so, why do we bother to see?

function __rtiRequest(zipCode) {
  return $.ajax({
    type: 'GET',
    data: {
      brandId: 1,
      resultsMax: 20,
      searchMode: 'pmaProximityLayered',
      zipcode: zipCode,
      excludeAttributeKey: 'ServiceCenterOnly',
      appKey: '7033548c4e5e4270b5336c904c92c2e2',
      resultsMode: 'full',
      resultsFormat: 'json',
      attributeKey: 'RTI'
    },
    url: '/DISREST/rest/getDealers',
    dataType: 'json'
  });
}

export default function (zipCode) {
  return __rtiRequest(zipCode)
    .then(res => {
      if ($.isEmptyObject(res.showDealerLocatorDataArea)) {
        return null;
      }
      return batws.geo().search({ zipcode: zipCode });
    })
    .then(dealers => xformDealersCommon(dealers.dealerLocator))
    .then(xformed => xformed.filter(dealer => dealer.isPma));
};
